import React, { useState } from "react";
import Rectangle from "../../../Public/assets/img/Rectangle.svg";
import DownloadButton from "../../../Public/assets/img/DownloadButton.svg";
import { lienReportDownload } from "../../../api";
import ButtonLoader from "../../../Components/Loader";

const AccountOpeningLetter = ({ globalData }) => {
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    if (loading) return;

    setLoading(true);
    try {
      const payload = {
        accountStatementType: "GENERAL",
        accountId: globalData?.data?.accountId,
      };

      const resp = await lienReportDownload(payload);

      if (resp?.status === 200 && resp?.data) {
        const blob = new Blob([resp.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = "AccountOpeningLetter.pdf";
        link.click();

        window.URL.revokeObjectURL(url);
      }
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  return (
    <div className="mt-[40px] mb-[40px]">
      <div className="text-[20px] font-geomanistBold">
        Account opening letter
      </div>
      <div className="text-[14px] text-[rgb(118,124,143)]">
        Download your official account opening letter for verification and record-keeping.
      </div>

      <img className="w-[189px] mt-[20px]" src={Rectangle} alt="doc" />

      <div
        onClick={handleDownload}
        className={`mt-[20px] flex  w-[150px] h-[40px] rounded ${
          loading ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
        }`}
      >
        {loading ? (
          <ButtonLoader className="flex items-center justify-center w-[120px] h-[40px] bg-[rgb(0,97,211)] rounded" />
        ) : (
          <img src={DownloadButton} alt="download" />
        )}
      </div>
    </div>
  );
};

export default AccountOpeningLetter;
